import merge from 'lodash/merge';
import mergeDeep from '@utils/mergeDeep';
import { quizTypes, savedTypes, questionTypes } from '../constants';

const initialState = {
  data: {},
  bulkSubmitQueue: {},
  currentQuestion: {},
  isSubmitting: false,
  isBulkSubmitting: false,
  disableSubmit: false,
  answeredQuestionCount: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case quizTypes.UPDATE_QUESTIONS:
      return {
        ...state,
        data: mergeDeep(action.data, state.data)
      };

    case `${quizTypes.MARK_QUESTION}_SUCCESS`:
      return {
        ...state,
        data: {
          ...state.data,
          [action.questionUid]: merge(state.data[action.questionUid], {
            is_marked: action.isMarked
          })
        }
      };

    case `${quizTypes.SEND_VIEWED_QUESTION}_REQUEST`:
      return {
        ...state,
        disableSubmit: false
      };

    case `${quizTypes.SUBMIT_QUESTION_RESPONSE}_REQUEST`:
      return {
        ...state,
        isSubmitting: true,
        disableSubmit: action.isFirstAttempt,
        data: {
          ...state.data,
          [action.questionUid]: {
            ...state.data[action.questionUid],
            user_attempt_list: action.responseData.attempt_list,
            answerResponse: action.responseData
          }
        }
      };

    case `${quizTypes.SUBMIT_QUESTION_RESPONSE}_SUCCESS`: {
      const newBulkQueue = state.bulkSubmitQueue;
      if (newBulkQueue[action.questionUid])
        delete newBulkQueue[action.questionUid];
      return {
        ...state,
        isSubmitting: false,
        disableSubmit: false,
        bulkSubmitQueue: newBulkQueue
      };
    }

    case `${quizTypes.SUBMIT_QUESTION_RESPONSE}_FAILURE`: {
      let bulkSubmitQueue = {};
      if (action.addToBulkQueue) {
        bulkSubmitQueue = {
          ...state.bulkSubmitQueue,
          [action.questionUid]: {
            ...state.data[action.questionUid],
            user_attempt_list: action.responseData.attempt_list,
            answerResponse: action.responseData
          }
        };
      } else bulkSubmitQueue = state.bulkSubmitQueue;
      return {
        ...state,
        isSubmitting: false,
        disableSubmit: false,
        data: {
          ...state.data,
          [action.questionUid]: {
            ...state.data[action.questionUid],
            user_attempt_list: action.responseData.attempt_list,
            answerResponse: action.responseData
          }
        },
        bulkSubmitQueue
      };
    }

    case quizTypes.UPDATE_QUESTION_COUNT:
      return {
        ...state,
        answeredQuestionCount: {
          ...state.answeredQuestionCount,
          [action.sectionUID]: action.value || 0
        }
      };

    case quizTypes.SET_QUESTION_COUNT:
      return {
        ...state,
        answeredQuestionCount: {
          ...action.data
        }
      };

    case `${quizTypes.BULK_SUBMIT_ANSWERS}_REQUEST`:
      return { ...state, isBulkSubmitting: true };

    case `${quizTypes.BULK_SUBMIT_ANSWERS}_SUCCESS`: {
      const { bulkSubmitQueue, data } = state;
      action.attemptedQuestions.forEach((questionUid) => {
        if (bulkSubmitQueue[questionUid]) delete bulkSubmitQueue[questionUid];
      });
      const newData = { ...data, ...action.bulkSubmitQueue };
      return {
        ...state,
        data: newData,
        isBulkSubmitting: false,
        bulkSubmitQueue
      };
    }

    case `${savedTypes.REMOVE_SAVED_ENTITY}_SUCCESS`: {
      const { objectUid } = action;
      if (!state.data[objectUid]) return state;
      return {
        ...state,
        data: {
          ...state.data,
          [objectUid]: {
            ...state.data[objectUid],
            is_saved: false
          }
        }
      };
    }

    case `${savedTypes.SAVE_ENTITY}_SUCCESS`: {
      const { objectUid } = action;
      if (!state.data[objectUid]) return state;
      return {
        ...state,
        data: {
          ...state.data,
          [objectUid]: {
            ...state.data[objectUid],
            is_saved: true
          }
        }
      };
    }

    case `${quizTypes.BULK_SUBMIT_ANSWERS}_FAILURE`:
      return { ...state, isBulkSubmitting: false };

    case `${questionTypes.FETCH_QUESTION_DATA_V2}_SUCCESS`:
      return { ...state, currentQuestion: action.result };

    case `${quizTypes.FETCH_SESSION_QUESTIONS}_REQUEST`:
    case `${questionTypes.SAVE_QUESTION}_REQUEST`:
    case `${questionTypes.SUBMIT_SOLUTION_RECORDING}_REQUEST`:
    case `${questionTypes.SUBMIT_QUESTION_DETAILS}_REQUEST`:
      return { ...state, isSubmitting: true };

    case `${questionTypes.SUBMIT_QUESTION_DETAILS}_SUCCESS`:
      return {
        ...state,
        isSubmitting: false,
        currentQuestion: {
          ...state.currentQuestion,
          question: {
            ...state.currentQuestion.question,
            question: {
              ...state.currentQuestion.question.question,
              difficulty_level: action.difficulty_level,
              expected_time: action.expected_time
            }
          }
        }
      };

    case `${questionTypes.SUBMIT_SOLUTION_RECORDING}_FAILURE`:
    case `${questionTypes.SUBMIT_QUESTION_DETAILS}_FAILURE`:
    case `${questionTypes.SUBMIT_SOLUTION_RECORDING}_SUCCESS`:
    case `${quizTypes.FETCH_SESSION_QUESTIONS}_SUCCESS`:
    case `${quizTypes.FETCH_SESSION_QUESTIONS}_FAILURE`:
    case `${questionTypes.SAVE_QUESTION}_SUCCESS`:
    case `${questionTypes.SAVE_QUESTION}_FAILURE`:
      return { ...state, isSubmitting: false };

    case 'RESET_QUESTIONS_DATA':
      return {
        ...state,
        data: {}
      };

    default:
      return state;
  }
};

export default reducer;
